import RequestService from "src/services/requestService";
import ConfigurationService from "src/services/configurationService";
import ConfiguratorService from "src/services/configuratorService";
import CalculationService from "src/services/calculationService";

const useRequestService = (
  configuration: ConfigurationService,
  configurator: ConfiguratorService,
  calculationService: CalculationService,
) => {
  return new RequestService(configuration, configurator, calculationService);
};

export default useRequestService;
